module.exports = __webpack_public_path__ + "img/img-about.59fba13e.png";